/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BuchungsaenderungDto } from '../../models/buchungsaenderung-dto';

export interface GetAenderungenForBuchung$Plain$Params {

/**
 * ID der Buchung
 */
  buchungsId: string;
}

export function getAenderungenForBuchung$Plain(http: HttpClient, rootUrl: string, params: GetAenderungenForBuchung$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<BuchungsaenderungDto>>> {
  const rb = new RequestBuilder(rootUrl, getAenderungenForBuchung$Plain.PATH, 'get');
  if (params) {
    rb.path('buchungsId', params.buchungsId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<BuchungsaenderungDto>>;
    })
  );
}

getAenderungenForBuchung$Plain.PATH = '/v1/buchungen/{buchungsId}/aenderungen';
